namespace Matrix.Rebalancer {
    export interface TradeMacroStepForm {
        MacroCode: Serenity.StringEditor;
        StepNo: Serenity.IntegerEditor;
        AccountCode: FormatServiceLookupEditor;
        SecurityOrAccountCode: Serenity.StringEditor;
        Weight: Serenity.DecimalEditor;
        Strategy: Serenity.StringEditor;
        CashAccount: Serenity.StringEditor;
        Contra: Serenity.BooleanEditor;
        BalanceWeights: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class TradeMacroStepForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.TradeMacroStep';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TradeMacroStepForm.init)  {
                TradeMacroStepForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = FormatServiceLookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.BooleanEditor;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(TradeMacroStepForm, [
                    'MacroCode', w0,
                    'StepNo', w1,
                    'AccountCode', w2,
                    'SecurityOrAccountCode', w0,
                    'Weight', w3,
                    'Strategy', w0,
                    'CashAccount', w0,
                    'Contra', w4,
                    'BalanceWeights', w0,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6,
                    'Version', w5
                ]);
            }
        }
    }
}
